import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Header } from 'semantic-ui-react';
import { Bar } from 'react-chartjs-2';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { colors } from 'utils/colors';
import { RiskProfile, Logging } from 'actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHeartPulse,
  // eslint-disable-next-line import/extensions
} from '@fortawesome/free-solid-svg-icons';

import Button from '../Button';
import Results from './Results';
import ResultsNew from './ResultsNew';
// import { generateFullQuestionnairePDF } from './BuildRiskQuestionnairePDF';

class RiskQuestionnaire extends Component {
  state = {
    error: false,
    result: false,
    riskCapacity: null,
    riskTolerance: null,
    riskCapacityScore: null,
    riskToleranceScore: null,

    questionNumber: 0,
    answers: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  };

  componentDidMount() {
    const { monitoringResult, dispatch, isRiskProfilePage } = this.props;
    if (!isRiskProfilePage) {
      dispatch(RiskProfile.getRiskProfile());
      if (!monitoringResult) {
        dispatch(RiskProfile.getRiskProfileMonitoring());
      }
    }
    if (monitoringResult && monitoringResult.risk_question_answers) {
      this.setState({
        questionNumber: 13,
        answers: monitoringResult.risk_question_answers,
      });
      this.calcScore(monitoringResult.risk_question_answers);
    }
  }

  componentDidUpdate(prevProps) {
    const { monitoringResult, dispatch } = this.props;
    if (prevProps.monitoringResult !== monitoringResult) {
      if (monitoringResult && monitoringResult.risk_question_answers) {
        this.setState({
          questionNumber: 13,
          answers: monitoringResult.risk_question_answers,
        });
        this.calcScore(monitoringResult.risk_question_answers);
      } else if (!monitoringResult || !monitoringResult.risk_profile) {
        dispatch(Logging.logEvent('RiskProfileQuestionnaire_Started_Fresh'));
      }
    }
  }

  handleSubmit = () => {
    const { answers, riskValue } = this.state;

    const { dispatch, monitoringResult, riskProfile, closeModal } = this.props;
    const risk_question_answers =
      monitoringResult && monitoringResult.risk_question_answers;
    const answersUnchanged =
      Array.isArray(risk_question_answers) &&
      answers.length === risk_question_answers.length &&
      answers.every((val, i) => val === risk_question_answers[i]);

    if (answersUnchanged) return;

    const selectedPortfolioId = riskProfile.find(
      (p) => p.risk_category === riskValue
    ).id;

    if (monitoringResult) {
      dispatch(Logging.logEvent('RiskProfileQuestionnaire_Complete_Retake'));
    } else {
      dispatch(Logging.logEvent('RiskProfileQuestionnaire_Complete_Fresh'));
    }

    if (monitoringResult) {
      const params = {
        risk_question_answers: answers,
        risk_question_updated_on: new Date().toISOString().slice(0, 10),
        risk_profile: monitoringResult.risk_profile.id,
      };
      dispatch(RiskProfile.updateRiskProfileMonitoring(params));
    } else {
      const params = {
        risk_question_answers: answers,
        risk_question_updated_on: new Date().toISOString().slice(0, 10),
        risk_profile: selectedPortfolioId,
      };
      dispatch(RiskProfile.createRiskProfileMonitoring(params));
    }
    if (closeModal) {
      closeModal();
    }
  };

  calcScoreOld = (answers) => {
    // const { answers } = this.state;
    const isInvalid = answers.includes(0);
    const { isRiskProfilePage } = this.props;

    if (isInvalid) {
      this.setState({ error: true });
      return setTimeout(() => this.setState({ error: false }), 2000);
    }

    const updatedAnswers = [...answers];
    updatedAnswers[0] = 5 - updatedAnswers[0];
    switch (updatedAnswers[6]) {
      case 1:
        updatedAnswers[6] = 2;
        break;
      case 2:
        updatedAnswers[6] = 3;
        break;
      case 3:
        updatedAnswers[6] = 1;
        break;
      default:
        updatedAnswers[6] = 4;
        break;
    }

    const result = updatedAnswers.reduce((a, b) => a + b, 0);

    let content1 = '';
    let riskValue = '';
    let retValue = '';

    if (result >= 35) {
      content1 = 'All-in';
      riskValue = 'All-In';
      retValue = 'allin';
    } else if (result >= 29) {
      content1 = 'Adventurous';
      riskValue = 'Adventurous';
      retValue = 'adventurous';
    } else if (result >= 21) {
      content1 = 'Classic';
      riskValue = 'Classic';
      retValue = 'classic';
    } else if (result >= 15) {
      content1 = 'Cautious';
      riskValue = 'Cautious';
      retValue = 'cautious';
    } else {
      content1 = 'Playing-it-Safe';
      riskValue = 'Playing-It-Safe';
      retValue = 'safe';
    }

    if (this.props.riskResultChange) {
      if (isRiskProfilePage) {
        this.props.riskResultChange(null, { name: riskValue });
      } else {
        this.props.riskResultChange(null, { value: retValue });
      }
    }

    return this.setState({ result, content1, riskValue });
  };

  calcScore = (answers) => {
    const isInvalid = answers.includes(0) || answers.includes(null);

    if (answers[0] === null && answers[11] == null && answers[12] === null) {
      this.calcScoreOld(answers.filter((val) => val !== null));
      return null;
    }

    if (isInvalid) {
      this.setState({ error: true });
      return setTimeout(() => this.setState({ error: false }), 2000);
    }

    const updatedAnswers = [...answers];
    updatedAnswers[1] = 6 - updatedAnswers[1];
    switch (updatedAnswers[7]) {
      case 1:
        updatedAnswers[7] = 2;
        break;
      case 2:
        updatedAnswers[7] = 3;
        break;
      case 3:
        updatedAnswers[7] = 1;
        break;
      default:
        updatedAnswers[7] = 4;
        break;
    }

    const resultCapacity = updatedAnswers
      .slice(1, 7)
      .reduce((a, b) => a + b, 0);
    const resultTolerance = updatedAnswers.slice(7).reduce((a, b) => a + b, 0);

    let riskCapacityValue = '';
    let riskToleranceValue = '';

    if (resultCapacity >= 21) {
      riskCapacityValue = 'High';
    } else if (resultCapacity >= 16) {
      riskCapacityValue = 'Moderate to High';
    } else if (resultCapacity >= 11) {
      riskCapacityValue = 'Moderate';
    } else if (resultCapacity >= 7) {
      riskCapacityValue = 'Low to Moderate';
    } else {
      riskCapacityValue = 'Low';
    }

    if (resultTolerance >= 21) {
      riskToleranceValue = 'High';
    } else if (resultTolerance >= 16) {
      riskToleranceValue = 'Moderate to High';
    } else if (resultTolerance >= 11) {
      riskToleranceValue = 'Moderate';
    } else if (resultTolerance >= 7) {
      riskToleranceValue = 'Low to Moderate';
    } else {
      riskToleranceValue = 'Low';
    }

    let content1 = '';
    let riskValue = '';
    const riskScore = Math.min(resultCapacity, resultTolerance);
    if (riskScore >= 21) {
      content1 = 'Aggressive Growth';
      riskValue = 'All-In';
    } else if (riskScore >= 16) {
      content1 = 'Growth';
      riskValue = 'Adventurous';
    } else if (riskScore >= 11) {
      content1 = 'Balanced';
      riskValue = 'Classic';
    } else if (riskScore >= 7) {
      content1 = 'Conservative';
      riskValue = 'Cautious';
    } else {
      content1 = 'Very Conservative';
      riskValue = 'Playing-It-Safe';
    }

    if (this.props.riskResultChange) {
      this.props.riskResultChange(
        riskValue,
        riskCapacityValue,
        riskToleranceValue
      );
    }

    return this.setState({
      riskCapacity: riskCapacityValue,
      riskTolerance: riskToleranceValue,
      riskCapacityScore: resultCapacity,
      riskToleranceScore: resultTolerance,
      content1,
      riskValue,
    });
  };

  // generatePDFFillable = () => {
  //   generateFullQuestionnairePDF();
  // };

  // generatePDFResults = () => {
  //   const { answers } = this.state;
  //   const { history } = this.props;
  //   this.handleSubmit();
  //   localStorage.setItem('risk-questionnaire-answers', JSON.stringify(answers));
  //   return history.push(`/profile/risk-profile/pdf`);
  // };

  prevQuestion = () => {
    const { dispatch } = this.props;
    const { questionNumber, answers } = this.state;
    if (questionNumber >= answers.length) {
      dispatch(Logging.logEvent('RiskProfileQuestionnaire_Started_Retake'));
      this.setState({
        questionNumber: 0,
      });
      return;
    }
    if (questionNumber > 0) {
      this.setState({ questionNumber: questionNumber - 1, error: false });
    }
  };

  nextQuestion = () => {
    const { questionNumber, answers } = this.state;
    if (
      answers[questionNumber] === 0 ||
      answers[questionNumber] === null ||
      answers.slice(0, questionNumber).includes(null)
    ) {
      this.setState({ error: true });
      return;
    }
    this.setState({ error: false });

    this.setState({ questionNumber: questionNumber + 1 });
    if (questionNumber === 12) {
      this.calcScore(answers);
    } else if (questionNumber === 13) {
      this.handleSubmit();
      if (this.props.onComplete) {
        this.props.onComplete();
      }
    }
  };

  render() {
    const {
      result,
      content1,
      error,
      questionNumber,
      answers,
      riskCapacity,
      riskTolerance,
      riskCapacityScore,
      riskToleranceScore,
    } = this.state;
    const { monitoringResult, isRiskProfilePage } = this.props;
    const chartData = {
      labels: ['Portfolio 1', 'Portfolio 2', 'Portfolio 3', 'Portfolio 4'],
      datasets: [
        {
          label: 'Gains',
          stack: 'Dataset 1',
          backgroundColor: colors.blue,
          data: [10, 15, 25, 35],
        },
        {
          label: 'Losses',
          stack: 'Dataset 1',
          backgroundColor: colors.red,
          data: [-2, -5, -10, -15],
        },
      ],
    };
    const chartOptions = {
      tooltips: {
        callbacks: {
          label: (tooltipItem) => `${tooltipItem.yLabel}%`,
        },
      },
      scales: {
        yAxes: [
          {
            ticks: {
              min: -20,
              max: 40,
              callback: (value) => `${value}%`,
            },
          },
        ],
      },
    };

    const questions = [
      {
        question: 'What is the primary goal for your investments?',
        answers: [
          'I want to keep the money I have invested safe from short-term losses or readily available for short-term needs.',
          'I want to generate a steady stream of income from my investments and I am less concerned about growing the value of my investments.',
          'I want to generate some income with some opportunity for the investments to grow in value.',
          'I want to generate long-term growth from my investments.',
        ],
        name: 'q1',
      },
      {
        question: 'What is your current age?',
        answers: ['35 and under', '36-45', '46-55', '56-65', 'Over 65'],
        name: 'q2',
      },
      {
        question:
          'When do you expect to need to withdraw a significant portion (1/3 or more) of the money in your investment portfolio?',
        answers: [
          'Under 3 years',
          '3 to 10 years',
          '11-20 years',
          'Over 20 years',
        ],
        name: 'q3',
      },
      {
        question:
          'When you need the money, over what period of time will you withdraw the funds?',
        answers: [
          'I will fully withdraw the funds within 2 years',
          'I will gradually withdraw the funds over 3-5 years',
          'I will gradually withdraw the funds over 6-10 years',
          'I will gradually withdraw the funds over a period of 10 years or more',
        ],
        name: 'q4',
      },
      {
        question: 'What is your current annual income before tax?',
        answers: [
          'Under $50,000',
          '$50,000 - $100,000',
          '$100,001 - $150,000',
          'Over $150,000',
        ],
        name: 'q5',
      },
      {
        question:
          'What is your household net worth (total assets - total debt)?',
        answers: [
          'Under $100,000',
          '$100,001 - $300,000',
          '$300,001 - $500,000',
          'Over $500,000',
        ],
        name: 'q6',
      },
      {
        question:
          'Which of the following statements best describes your investment needs?',
        answers: [
          'I have no income from other sources and essentially rely on my savings',
          'I have a moderate income from other sources, but primarily rely on my investments',
          'I have a major source of income which I supplement with moderate income from my investments',
          'My income is more than adequate and I don’t have to rely on my investments',
        ],
        name: 'q7',
      },
      {
        question: 'Which of the following situations upset you the most?',
        answers: [
          'You wake up one morning to learn the value of your investments went down by 25% overnight',
          'You have just realized that you have forgone a 25% rally in stocks because you were heavily invested in bonds',
          'Both of the above',
          'None of the above',
        ],
        name: 'q8',
      },
      {
        question:
          'Which of the following statements best describes your reaction to fluctuations in the value of your portfolio?',
        answers: [
          'I will immediately sell any holding in my portfolio if its value drops sharply or if I am losing money',
          'I am uncomfortable with short-term fluctuations, but would wait at least 3 months before selling',
          'I would watch the market and wait at least a year before making a decision to sell',
          'I am committed to a long-term strategy, and would not change my portfolio even if one of my holdings suffered a significant drop in value for over a year',
        ],
        name: 'q9',
      },
      {
        question:
          'Over time, the purchasing power of your investments will diminish due to inflation. Investments that have a higher potential to outpace inflation may also be more volatile. Which of the following statements is closer to your views on investing with respect to inflation?',
        answers: [
          'I prefer stable returns, even if this means that I may just keep up with or marginally beat inflation',
          'I prefer to exceed inflation substantially, but I am not comfortable with volatility',
          'I prefer stable returns, but it’s more important that my gains exceed inflation',
          'I want to maximize the return on my investments, and I accept that from time to time the value of my investments may decline',
        ],
        name: 'q10',
      },
      {
        question:
          'The chart below illustrates the potential range of returns and losses of four different portfolios, over a 1-year period. Which portfolio would you be most comfortable with?',
        answers: ['Portfolio 1', 'Portfolio 2', 'Portfolio 3', 'Portfolio 4'],
        name: 'q11',
      },
      {
        question:
          'How would you feel if your portfolio dropped 20% in value over six months?',
        answers: [
          'Very concerned – I would move to safe investments',
          'Concerned but would wait and see',
          'Comfortable – I understand markets fluctuate',
          'Unconcerned – I would see it as a buying opportunity',
        ],
        name: 'q12',
      },
      {
        question:
          'What is the maximum loss you could tolerate in any single year before you would change your strategy?',
        answers: ['Less than 5%', '5-10%', '10-20%', 'More than 20%'],
        name: 'q13',
      },
    ];

    const fomoDetected = answers[7] === 2;
    const recencyBiasDetected = answers[8] === 1 || answers[8] === 2;
    const risk_question_answers =
      monitoringResult && monitoringResult.risk_question_answers;
    const total = questions.length;

    const isResults = questionNumber >= total;

    const answersUnchanged =
      Array.isArray(risk_question_answers) &&
      answers.length === risk_question_answers.length &&
      answers.every((val, i) => val === risk_question_answers[i]);

    return (
      <div style={{ width: '90%', margin: '0 auto' }}>
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Header as="h2" style={{ marginTop: '10px' }}>
            <FontAwesomeIcon
              icon={faHeartPulse}
              style={{ marginRight: '1rem', fontSize: '21px' }}
            />
            Risk Profile Questionnaire
          </Header>
          {questionNumber < answers.length && (
            <p style={{ color: 'black', maxWidth: '43rem' }}>
              Your risk profile plays a crucial role in shaping your investment
              strategy. The following questions are designed to evaluate your
              investment objectives, risk capacity and risk tolerance.
            </p>
          )}
          {isRiskProfilePage && questionNumber === 0 && (
            <p style={{ color: '#6D6E71', textAlign: 'left' }}>
              If you already have a risk profile in mind, you can skip this
              questionnaire by clicking the Profile Confirmation tab above.
            </p>
          )}
        </div>

        {/* {(questionNumber === 0 || questionNumber === 10) && (
          <Button
            className={cn('left')}
            color={colors.darkGrey}
            icon="file text"
            onClick={() => {
              if (questionNumber === 0) {
                this.generatePDFFillable();
              } else {
                this.generatePDFResults();
              }
            }}
            style={{ position: 'absolute', top: 20, right: 20 }}
          >
            {questionNumber === 0 ? 'Fillable PDF' : 'PDF Results'}
          </Button>
        )} */}
        {questionNumber < 13 ? (
          // eslint-disable-next-line react/jsx-fragments
          <React.Fragment>
            <Section>
              <OverviewHeader>
                <p>
                  <b>Question {questionNumber + 1} of 13</b>
                </p>
              </OverviewHeader>
              <CategoryLabels>
                <CategoryLabel
                  active={questionNumber < 1}
                  done={questionNumber >= 1}
                  color="#203180"
                >
                  1. Investment Objectives
                </CategoryLabel>
                <CategoryLabel
                  active={questionNumber >= 1 && questionNumber < 7}
                  done={questionNumber >= 7}
                  color="#6b88fa"
                >
                  2. Risk Capacity
                </CategoryLabel>
                <CategoryLabel
                  active={questionNumber >= 7}
                  done={false}
                  color="#fac27d"
                >
                  3. Risk Tolerance
                </CategoryLabel>
              </CategoryLabels>
              <SegmentedProgressBar>
                <ProgressSegment position="first">
                  <ProgressFill
                    percent={Math.min(questionNumber / 1, 1) * 100}
                    color="#203180"
                    position="first"
                  />
                </ProgressSegment>
                <ProgressSegment position="middle">
                  <ProgressFill
                    percent={
                      Math.min(Math.max((questionNumber - 1) / 6, 0), 1) * 100
                    }
                    color="#6b88fa"
                    position="middle"
                  />
                </ProgressSegment>
                <ProgressSegment position="last">
                  <ProgressFill
                    percent={
                      Math.min(Math.max((questionNumber - 7) / 6, 0), 1) * 100
                    }
                    color="#fac27d"
                    position="last"
                  />
                </ProgressSegment>
              </SegmentedProgressBar>
            </Section>
            <Section>
              <Header
                size="medium"
                content={questions[questionNumber].question}
              />
              {questions[questionNumber].answers.map((answer, index) => (
                <Answer key={index}>
                  <input
                    type="radio"
                    name={`question-${questionNumber}`}
                    value={index + 1}
                    checked={answers[questionNumber] === index + 1}
                    onChange={() => {
                      const updatedAnswers = [...this.state.answers];
                      updatedAnswers[questionNumber] = index + 1;
                      this.setState({ answers: updatedAnswers });
                    }}
                    style={{ marginRight: '0.5em', alignSelf: 'center' }}
                  />
                  {answer}
                </Answer>
              ))}
              {questionNumber === 10 && (
                <div style={{ width: '70%', margin: '0 auto' }}>
                  <Bar data={chartData} options={chartOptions} />
                </div>
              )}
            </Section>
          </React.Fragment>
        ) : (
          <Section style={{ marginTop: 0 }}>
            {answers.includes(null) ? (
              <Results
                score={result}
                plan={content1}
                date={
                  (monitoringResult &&
                    monitoringResult.risk_question_updated_on) ||
                  new Date().toISOString().slice(0, 10)
                }
              />
            ) : (
              <ResultsNew
                plan={content1}
                capacityLabel={riskCapacity}
                capacityScore={riskCapacityScore}
                toleranceLabel={riskTolerance}
                toleranceScore={riskToleranceScore}
                fomoDetected={fomoDetected}
                recencyBiasDetected={recencyBiasDetected}
                date={
                  (monitoringResult &&
                    monitoringResult.risk_question_updated_on) ||
                  new Date().toISOString().slice(0, 10)
                }
              />
            )}
          </Section>
        )}

        <Navigation>
          {questionNumber > 0 && (
            <Button
              className="left"
              color={colors.blue}
              icon={questionNumber >= answers.length ? 'undo' : 'chevron left'}
              floated="left"
              onClick={this.prevQuestion}
            >
              {questionNumber >= answers.length
                ? 'Revisit Questionnaire'
                : 'Back'}
            </Button>
          )}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {error &&
              (answers[questionNumber] === 0 ||
                answers[questionNumber] === null) && (
                <div
                  style={{
                    color: colors.red,
                    marginBottom: '0.5rem',
                    textAlign: 'center',
                  }}
                >
                  Please select an answer.
                </div>
              )}
            {error && answers.slice(0, questionNumber).includes(null) && (
              <div style={{ color: colors.red, textAlign: 'center' }}>
                You are missing a previous answer. Please go back and complete
                it.
              </div>
            )}
          </div>

          <Button
            className="right"
            color={colors.blue}
            icon={isResults && !answersUnchanged ? 'save' : 'chevron right'}
            floated="right"
            onClick={this.nextQuestion}
          >
            {isResults && !answersUnchanged ? 'Save' : 'Next'}
          </Button>
        </Navigation>
      </div>
    );
  }
}

RiskQuestionnaire.propTypes = {
  riskResultChange: PropTypes.func,
  onComplete: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  monitoringResult: PropTypes.object,
  history: PropTypes.object,
  riskProfile: PropTypes.array,
  closeModal: PropTypes.func,
  isRiskProfilePage: PropTypes.bool,
};

RiskQuestionnaire.defaultProps = {
  riskResultChange: undefined,
  onComplete: undefined,
  monitoringResult: null,
  history: {},
  riskProfile: [],
  closeModal: null,
  isRiskProfilePage: false,
};
export default withRouter(
  connect((state) => ({
    monitoringResult: state.RiskProfile.monitoringResult,
    riskProfile: state.RiskProfile.riskProfile,
  }))(RiskQuestionnaire)
);

const OverviewHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const CategoryLabels = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 6px;
`;

const CategoryLabel = styled.span`
  flex: 1;
  text-align: left;
  font-size: 1.14rem;
  font-weight: ${({ active }) => (active ? '700' : '400')};
  color: ${({ active, done, color }) =>
    active ? color : done ? 'black' : '#ccc'};
`;

const SegmentedProgressBar = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  height: 10px;
  border-radius: 50px;
  overflow: hidden;
`;

const ProgressSegment = styled.div`
  flex: 1;
  background-color: ${colors.lightGrey};
  border-radius: ${({ position }) =>
    position === 'first'
      ? '50px 0 0 50px'
      : position === 'last'
      ? '0 50px 50px 0'
      : '0'};
  overflow: hidden;
`;

const ProgressFill = styled.div`
  height: 100%;
  width: ${({ percent }) => percent}%;
  background-color: ${({ color }) => color};
  border-radius: ${({ position }) =>
    position === 'first'
      ? '50px 0 0 50px'
      : position === 'last'
      ? '0 50px 50px 0'
      : '0'};
  transition: width 0.3s ease;
`;

const Section = styled.div`
  width: 100%;
  padding: 0;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const Answer = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.5em;
  margin-bottom: 1em;
  padding: 10px;
  cursor: pointer;
  border: 1px solid #d4d4d5;
  border-radius: 4px;
  font-size: 1.1rem;
`;
const Navigation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
`;
